/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IClasesTecnicas from './entidades/clasesTecnicas';
import IFiltrosClasesTecnicas from './entidades/filtrosClasesTecnicas';

export default class ModeloClasesTecnicas {
    public consultarClasesTecnicas() {
        return manejadorRest<IRespuesta<IClasesTecnicas>>(() => negocioConfiguracion.get('ClaseTecnica/ConsultarListaClaseTecnica'));
    }
    public crearClasesTecnicas(clasesTecnicas: IClasesTecnicas) {
        return manejadorRest<IRespuesta<IClasesTecnicas>>(() =>
            negocioConfiguracion.post('ClaseTecnica/GuardarClaseTecnica', clasesTecnicas)
        );
    }
    public editarClasesTecnicas(clasesTecnicas: IClasesTecnicas) {
        return manejadorRest<IRespuesta<IClasesTecnicas>>(() =>
            negocioConfiguracion.put('ClaseTecnica/EditarClaseTecnica', clasesTecnicas)
        );
    }
    public eliminarClasesTecnicas(clasesTecnicas: IClasesTecnicas) {
        return manejadorRest<IRespuesta<IClasesTecnicas>>(() =>
            negocioConfiguracion.delete('ClaseTecnica/EliminarClaseTecnica', clasesTecnicas)
        );
    }
    public consultarListaClasesTecnicasPorFiltro(filtrosClasesTecnicas: IFiltrosClasesTecnicas) {
        return manejadorRest<IRespuesta<IClasesTecnicas>>(
            () => negocioConfiguracion.post('ClaseTecnica/ConsultarListaClaseTecnicaPorFiltro', filtrosClasesTecnicas),
            true
        );
    }
}
